export const discount = {
    1: "FLAT 80% off on your first booking at this center",
    2: "FLAT 80% off on your first booking at this center",
    3: "",
    4: "FLAT 80% off on your first booking at this center",
    5: "",
    6: "",
    7: "FLAT 80% off on your first booking at this center",
    8: "FLAT 80% off on your first booking at this center",
    9: "FLAT 80% off on your first booking at this center",
    10: "FLAT 80% off on your first booking at this center",
    11: "FLAT 80% off on your first booking at this center",
    12: "FLAT 80% off on your first booking at this center",
    13: "FLAT 80% off on your first booking at this center",
    14: "FLAT 80% off on your first booking at this center",
    15:"",
    16:"",
    17:"",
    18: "FLAT 80% off on your first booking at this center",
    20: "FLAT 80% off on your first booking at this center",
    21: "FLAT 80% off on your first booking at this center",
    22: "FLAT 80% off on your first booking at this center",
    23: "",
    24: "FLAT 80% off on your first booking at this center",
    25: "FLAT 80% off on your first booking at this center",
    26: "",
    27: "",
    28: "",
    29: "FLAT 40% off on your first booking at this center",
    30: "",
    31: "50% off upto Rs.75 on your first booking at this center",
    32: "",
    33: "",
    34: "20% off upto Rs.50 on your first booking at this center",
    35: "",
    36:"",
    37:"",
    38: "",
    39: "FLAT 5% off on your first booking at this center",
    40: "",
    41: "FLAT 5% off on your first booking at this center",
    42: "",
    43: "",
    44: "",
    45: "",
    46: "",
    47: "",
    48: "",
    49: "",
    50: ""
}